import { render, staticRenderFns } from "./SourceStatistics.vue?vue&type=template&id=6705527c&scoped=true"
import script from "./SourceStatistics.vue?vue&type=script&lang=js"
export * from "./SourceStatistics.vue?vue&type=script&lang=js"
import style0 from "./SourceStatistics.vue?vue&type=style&index=0&id=6705527c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705527c",
  null
  
)

export default component.exports